import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as CloseBtn } from "../../../assets/icons/Icon.svg";
import { UPDATE_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import "moment/locale/az";
import "./style.css";

import UpdatesModalStudentDetails from "./UpdatesModalStudentDetails";
import UpdatesModalTuitionFeeDetails from "./UpdatesModalTuitionFeeDetails";
import UpdatesModalGroupDetails from "./UpdatesModalGroupDetails";

const UpdatesModal = () => {
  const dispatch = useDispatch();
  const { updatesModalData } = useSelector((state) => state.updatesModal);

  const closeModal = () => {
    dispatch({
      type: UPDATE_MODAL_ACTION_TYPE.GET_UPDATES_MODAL,
      payload: { data: {}, openModal: false },
    });
  };

  return (
    <div className="create-update-modal-con">
      <div className="create-update-modal updates">
        <div className="create-update-modal-head">
          <h2>Yeniləmələr</h2>
          <CloseBtn onClick={closeModal} />
        </div>
        {updatesModalData.modelName === "student" && (
          <UpdatesModalStudentDetails />
        )}
        {updatesModalData.modelName === "tuition-fee" && (
          <UpdatesModalTuitionFeeDetails />
        )}
        {updatesModalData.modelName === "group" && <UpdatesModalGroupDetails />}
      </div>
    </div>
  );
};

export default UpdatesModal;
